// removed by extract-text-webpack-plugin
module.exports = {"container":"_2BwuVslftSWehxbhBUuVAv","title":"_36U_sm-U2F0qWaXKmoWts-","blurb":"_1jR_s35HNlrWEov8zUNvmv","projects":"_4AQVM6t2DK5vLhr04HNRw","blue":"_3qYEVE8c256Z48fU2i9Fe8","green":"_3KwVp76V5hgTNNsR2pT4P2","yellow":"CuxA-4tNdg6MTkhN3-pxB","purple":"_31rnejnhfli64R-hXTo68r"};


//////////////////
// WEBPACK FOOTER
// ./src/Projects.css
// module id = 328
// module chunks = 0